export const FETCH_PROVIDERS = 'FETCH_PROVIDERS' as const;
export const FETCH_PROVIDERS_SUCCESS = 'FETCH_PROVIDERS_SUCCESS' as const;
export const FETCH_PROVIDERS_FAIL = 'FETCH_PROVIDERS_FAIL' as const;
export const FETCH_PROVIDERS_CANCEL = 'FETCH_PROVIDERS_CANCEL' as const;
export const CLEAR_PROVIDERS = 'CLEAR_PROVIDERS' as const;

export const FETCH_PROVIDERS_PAGE = 'FETCH_PROVIDERS_PAGE' as const;
